import {
  //
  GET_WARNINGS,
  GET_WARNINGS_SUCCESS,
  GET_WARNINGS_FAILURE,
  //
  SAVE_WARNING,
  SAVE_WARNING_SUCCESS,
  SAVE_WARNING_FAILURE,
  //
  UPDATE_WARNING,
  UPDATE_WARNING_SUCCESS,
  UPDATE_WARNING_FAILURE,
} from "./constants";

// List
export const getWarnings = (payload, onSuccess) => ({
  type: GET_WARNINGS,
  payload,
  onSuccess,
});
export const getWarningsSuccess = (payload) => ({
  type: GET_WARNINGS_SUCCESS,
  payload,
});
export const getWarningsFailure = (payload) => ({
  type: GET_WARNINGS_FAILURE,
  payload,
});

// Save Template Data
export const saveWarning = (payload, onSuccess) => ({
  type: SAVE_WARNING,
  payload,
  onSuccess,
});
export const saveWarningSuccess = (payload) => ({
  type: SAVE_WARNING_SUCCESS,
  payload,
});
export const saveWarningFailure = (payload) => ({
  type: SAVE_WARNING_FAILURE,
  payload,
});

// Update Template Data
export const updateWarning = (payload, onUpdate) => ({
  type: UPDATE_WARNING,
  payload,
  onUpdate,
});
export const updateWarningSuccess = (payload) => ({
  type: UPDATE_WARNING_SUCCESS,
  payload,
});
export const updateWarningFailure = (payload) => ({
  type: UPDATE_WARNING_FAILURE,
  payload,
});
